import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUDGPD_INF_CONT;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },

  put(payload) {
    return baseApi.put(resource, payload);
  },
};
